
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// More robust production detection based on URL
const isProduction = window.location.hostname !== 'localhost' && 
                     !window.location.hostname.includes('127.0.0.1') && 
                     !window.location.hostname.includes('0.0.0.0');

// Add TypeScript declaration for the custom property
declare global {
  interface Window {
    __IS_PRODUCTION__: boolean;
    __LAST_UPDATE_TIMESTAMP__: number;
    __UPDATE_ACKNOWLEDGED__: boolean;
  }
}

// Set the production flag globally
window.__IS_PRODUCTION__ = isProduction;

// Set update timestamp to track updates
window.__LAST_UPDATE_TIMESTAMP__ = Date.now();

// Initialize update acknowledgment flag
window.__UPDATE_ACKNOWLEDGED__ = true;

// Force reload if no data is present
try {
  const hasCategories = localStorage.getItem('categories');
  const hasResources = localStorage.getItem('resources');
  
  if (!hasCategories || !hasResources) {
    console.log('No data found in localStorage, loading defaults');
    const defaultCategories = require('./data/mockData').defaultCategories;
    const defaultResources = require('./data/mockData').defaultResources;
    
    localStorage.setItem('categories', JSON.stringify(defaultCategories));
    localStorage.setItem('resources', JSON.stringify(defaultResources));
    console.log('Default data loaded successfully');
  }
} catch (e) {
  console.error('Error checking/initializing data:', e);
}

// Prevent caching
const META_REFRESH_HEADER = document.createElement('meta');
META_REFRESH_HEADER.httpEquiv = 'Cache-Control';
META_REFRESH_HEADER.content = 'no-cache, no-store, must-revalidate';
document.head.appendChild(META_REFRESH_HEADER);

const PRAGMA_HEADER = document.createElement('meta');
PRAGMA_HEADER.httpEquiv = 'Pragma';
PRAGMA_HEADER.content = 'no-cache';
document.head.appendChild(PRAGMA_HEADER);

const EXPIRES_HEADER = document.createElement('meta');
EXPIRES_HEADER.httpEquiv = 'Expires';
EXPIRES_HEADER.content = '0';
document.head.appendChild(EXPIRES_HEADER);

// Add utility function to fix broken images
const fixBrokenImages = () => {
  document.querySelectorAll('img').forEach(img => {
    img.onerror = function() {
      console.log('Image failed to load, setting fallback:', img.src);
      if (img.src.includes('category')) {
        img.src = 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3';
      } else {
        img.src = 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b';
      }
    };
  });
};

// Run the fix broken images function
document.addEventListener('DOMContentLoaded', fixBrokenImages);
window.addEventListener('load', fixBrokenImages);

// Add a force update event listener
window.addEventListener('force:app:update', () => {
  console.log('Force update event received, refreshing content');
});

// Modify the createRoot call to include error handling
try {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    console.error("Root element not found!");
  } else {
    createRoot(rootElement).render(<App />);
  }
} catch (error) {
  console.error("Error rendering the application:", error);
}
